import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ImpressumPage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-page)' }}>
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b" style={{ background: 'var(--bg-page)', borderColor: 'var(--border-light)' }}>
        <div className="container">
          <div className="flex justify-between items-center py-4">
            <span
              className="text-2xl font-bold cursor-pointer"
              style={{ color: 'var(--brand-primary)' }}
              onClick={() => navigate('/')}
            >
              planniq
            </span>
            <button
              onClick={() => navigate('/')}
              className="btn-secondary flex items-center gap-2"
              style={{ padding: '0.5rem 1.25rem' }}
            >
              <ArrowLeft size={16} />
              Zurück
            </button>
          </div>
        </div>
      </nav>

      <div className="pt-32 pb-20">
        <div className="container">
          <div className="max-w-2xl">
            <h1 className="heading-2 mb-12" style={{ color: 'var(--text-primary)' }}>Impressum</h1>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>Medieninhaber und Herausgeber</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Seidl Jakob<br />
                Moritz Langbrucker<br />
                <br />
                Amerlingstraße 15/14<br />
                1060 Wien<br />
                Österreich
              </p>
            </section>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>Kontakt</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                E-Mail: <a href="mailto:hello@planniq.at" style={{ color: 'var(--brand-primary)' }}>hello@planniq.at</a><br />
                Telefon: <a href="tel:+436606041926" style={{ color: 'var(--brand-primary)' }}>+43 660 6041926</a>
              </p>
            </section>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>Unternehmensgegenstand</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Frühe Entwicklung und Validierung eines Software-Konzepts im Bereich Budgetsteuerung und betrieblicher Finanzprozesse.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="heading-4 mb-4" style={{ color: 'var(--text-primary)' }}>Grundlegende Richtung der Website</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Vorstellung des Projekts planniq sowie Information über das Themenfeld Budgetsteuerung und Kontaktmöglichkeit für Interessenten und potenzielle Pilotkunden.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
